module.exports = __webpack_public_path__ + "media/images/flags/AF-7b83b39fe1ab1ba866e009ad0b5242d3.svg";